import { createAction } from "@reduxjs/toolkit";

export const reset = createAction("RESET");
